import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import { StatusBadge } from "../components/StatusBadge";
import api from "../lib/api";
import { ClipboardList } from "lucide-react";

export default function Solicitudes() {
  const { setMobileOpen } = useOutletContext();
  const [retiros, setRetiros] = useState([]);
  const [envios, setEnvios] = useState([]);
  const load = useCallback(() => {
    api.get("/retiros").then(({ data }) => setRetiros(data.filter((r) => r.status === "solicitado"))).catch(() => {});
    api.get("/envios?status=solicitado").then(({ data }) => setEnvios(data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <>
      <Header title="Solicitudes" subtitle="Solicitudes de retiro y envíos pendientes" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8 space-y-6">
        <section>
          <h3 className="text-sm font-semibold text-[#64748B] mb-3 uppercase tracking-wide">Retiros solicitados ({retiros.length})</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {retiros.map((r) => (
              <div key={r.id} className="bg-white rounded-xl border border-[#E2E8F0] p-5 shadow-sm">
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-lg bg-amber-50 border border-amber-200 flex items-center justify-center"><ClipboardList className="h-5 w-5 text-[#F5A623]" /></div>
                  <div>
                    <div className="font-bold text-[#0A1F44]">{r.cliente_nombre}</div>
                    <div className="text-xs text-[#64748B]">{r.ciudad} · {r.sucursal_origen}</div>
                  </div>
                </div>
                <div className="mt-3 text-sm text-[#64748B]">{r.direccion}</div>
              </div>
            ))}
            {retiros.length === 0 && <div className="col-span-full text-center py-8 text-[#64748B] bg-white rounded-xl border border-[#E2E8F0]">Sin retiros pendientes.</div>}
          </div>
        </section>
        <section>
          <h3 className="text-sm font-semibold text-[#64748B] mb-3 uppercase tracking-wide">Envíos en estado Solicitado ({envios.length})</h3>
          <div className="bg-white rounded-xl border border-[#E2E8F0] shadow-sm overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-[#64748B] text-xs uppercase"><tr><th className="text-left font-semibold px-4 py-3">Código</th><th className="text-left font-semibold px-4 py-3">Destinatario</th><th className="text-left font-semibold px-4 py-3">Estado</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {envios.map((e) => (
                  <tr key={e.id} className="hover:bg-slate-50/60"><td className="px-4 py-3 font-mono font-bold text-xs">{e.code}</td><td className="px-4 py-3">{e.destinatario} · {e.ciudad}</td><td className="px-4 py-3"><StatusBadge status={e.status} /></td></tr>
                ))}
                {envios.length === 0 && <tr><td colSpan={3} className="px-4 py-10 text-center text-[#64748B]">No hay envíos solicitados.</td></tr>}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </>
  );
}
